export default {
	data() {
		return {
			
		}
	},
	props: ['id', 'title'],
	created(){
		
	},
	methods: {
		closeModale(){
			this.$emit('close_modale')
			this.$store.commit('UI_SET_MODALE_GAUCHE', null)
		}
	},
	computed:{
		
	},
	components:{
		
	}
}